<template>
  <div>
    <b-progress animated class="mt-2" :max="max">
      <b-progress-bar
        v-for="index in count"
        :key="index"
        :value="max / (range.length - 1)"
        variant="success"
      >
      </b-progress-bar>
    </b-progress>
    <b-row class="mt-2">
      <b-col class="d-flex justify-content-between">
        <span
          style="font-size:18px"
          :class="
            `badge rounded-pill  bg-${$getItemColorView({
              statusid: item.id,
            })}`
          "
          v-for="(item, index) in range"
          :key="index + 'key'"
        >
          {{ item.label }}
        </span>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import VueSlideBar from "vue-slide-bar";
export default {
  components: { VueSlideBar },
  props: {
    id: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      value: 100,
      range: [
        {
          id: 15,
          label: this.$t("created"),
        },
        {
          id: 16,
          label: this.$t("modified"),
        },
        {
          id: 18,
          label: this.$t("sent"),
        },
        {
          id: 19,
          label: this.$t("accepted"),
        },

        {
          id: 20,
          label: this.$t("rejected"),
        },
        {
          id: 21,
          label: this.$t("estimated"),
        },
        {
          id: 23,
          label: this.$t("canceled"),
        },
        {
          id: 22,
          label: this.$t("approved"),
        },
      ],
      max: 100,
      count: 0,
    };
  },
  created() {
    this.count = this.range.indexOf(
      this.range.filter((item) => item.id == this.id)[0]
    );
    console.log(this.id);
    console.log(this.range.filter((item) => item.id == this.id)[0]);
    console.log(this.count);
  },
};
</script>

<style></style>
